import { Component } from 'react';
import * as Sentry from '@sentry/react';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
    // Forward to Sentry if initialized (no-op otherwise)
    Sentry.captureException(error, {
      contexts: {
        react: {
          componentStack: errorInfo?.componentStack,
        },
      },
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-[400px] items-center justify-center px-4">
          <div className="text-center">
            <h2 className="text-xl font-semibold text-[var(--ui-text)]">
              Une erreur est survenue
            </h2>
            <p className="mt-2 text-[var(--ui-text-muted)]">
              Notre équipe a été alertée. Vous pouvez actualiser la page ou nous contacter à{' '}
              <a href="mailto:contact@djodjo.tg" className="underline">
                contact@djodjo.tg
              </a>
              .
            </p>
            <button
              onClick={() => this.setState({ hasError: false })}
              className="mt-4 rounded-lg bg-emerald-600 px-4 py-2 text-sm font-medium text-white hover:bg-emerald-700"
            >
              Réessayer
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
